import React from 'react';
import additional from './personnel_color.svg'

const Personnel_color = ({ isMobile }) => {
  return (
    <img width={isMobile ? "36" : "56"} height={isMobile ? "36" : "56"} src={additional} />
  )
};

export default Personnel_color;
